import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center pa-2 pt-12 pb-6"},[_c(VImg,{staticClass:"mb-5",attrs:{"height":"300px","contain":"","src":"/images/error.svg"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }